<template>
    <div class="" :class="'map'+type" :ref="id" :id="'mappaMini'+id" v-resize="onResize">
      <div :id="'popup' + id" class="ol-popup opensanslight size8">
        <div :id="'popup-content' + id"></div>
      </div>
      <a id="image-download" download="map.jpg"></a>
    </div>
    
</template>
<script>

import 'ol/ol.css'
import {Map, View} from 'ol'
import Overlay from 'ol/Overlay'
import XYZ from 'ol/source/XYZ'
import TileLayer from 'ol/layer/Tile'
import {Polygon} from 'ol/geom'
import {MultiPolygon} from 'ol/geom'
import Feature from 'ol/Feature'
import { formatNumber } from '../utils/misc'
import {toLonLat} from 'ol/proj'
import {getBottomLeft, getTopRight} from 'ol/extent'
import * as proj from "ol/proj"
import Control from 'ol/control/Control'
import jsPDF from 'jspdf'
import { toJpeg } from "html-to-image"
import {ScaleLine} from 'ol/control'
import {Fill, Stroke, Style} from 'ol/style'
import VectorImageLayer from 'ol/layer/VectorImage'
import {defaults} from 'ol/interaction'
// import { consoleError } from 'vuetify/lib/util/console'
// import {fromLonLat} from 'ol/proj';
// import proj4 from 'proj4'


'use strict'
  export default {
    name: 'Map',
    props: {
      selector: String,
      type: String,
      projection: String,
      id: String,
      start: String,
      end: String,
      zoom: String,
      main_layer: {type: Object},
      },
    components: {},
     watch: {
      start: function () {
        this.zoomToExtent()
      },
      '$store.getters.indicator': function() {
          //console.log('store.getters.indicator');
          //this.$root.$emit('manage_country_polygon')
      },
      '$store.getters.TL': function() {
        //this.changeTL()
        this.changeTL = true
        //console.log('>>>>>MAP>>>>> $store.getters.TL ' + this.$store.getters.TL);
      },
      '$store.getters.polygon_layer': function() {
        console.log("*** $store.getters.polygon_layer ***")
        this.changeLayers()
      },
      '$store.getters.TU': function() {
        //console.log('>>>>>MAP>>>>> $store.getters.TU ' + this.$store.getters.TU)
        console.log("*** $store.getters.TU ***")
        this.changeLayers()
        this.zoomToExtent()
      },

      '$store.getters.countryID': function() {
      },      
    }, 

    methods: {
        setOverlayPopup: function () {
          //console.log('setOverlayPopup')
          let container = document.getElementById('popup' + this.id)
          this.content = document.getElementById('popup-content' + this.id)
          // let closer = document.getElementById('popup-closer');
          this.overlayPopup = new Overlay({
            element: container,
            autoPan: false,
          })
        },      
        exportMap: async function (type) {
          this.$store.commit('setshow_overlay', true)
          this.addLegendToMap()
          var format = 'a4'
          var resolution = 150
          var dim = [297, 210]
          var width = Math.round(dim[0] * resolution / 25.4);
          var height = Math.round(dim[1] * resolution / 25.4);
          
          var viewResolution = this.map.getView().getResolution();
          var size = this.map.getSize();

          var exportOptions = {
            filter: function(element) {
              return element
            }
          };
          var map  = this.map

          if (map !== undefined) {
              await map.once("rendercomplete", function() {
                exportOptions.width = width;
                exportOptions.height = height;

                toJpeg(map.getViewport(), exportOptions).then(function(dataUrl) {
                  if (type === 'JPG') {
                    var link = document.getElementById('image-download');
                    link.href = dataUrl
                    link.click();
                  }
                  else{
                    var pdf = new jsPDF("landscape", undefined, format);
                    pdf.addImage(dataUrl, "JPEG", 0, 0, dim[0], dim[1]);
                    pdf.save("map.pdf");
                  }
                  // Reset original map size
                  map.setSize(size);
                  map.getView().setResolution(viewResolution);
                });
              });

              // Set print size
              var printSize = [width, height];
              map.setSize(printSize);
              var scaling = Math.min(width / size[0], height / size[1]);
              map.getView().setResolution(viewResolution / scaling);

              //map.removeControl(this.controlLegend)
              if (type === 'JPG') {
                this.$root.$once('map_2_jpg', () => {
                  this.exportMap('JPG')
                  })                
              }
              else {
                this.$root.$once('map_2_pdf', () => {
                  this.exportMap('PDF')
                  })
                }
            }
        this.$store.commit('setshow_overlay', false)
        },
        scaleControl() {
          var className = 'ol-scale-line'
          switch (this.id) {
            case 'h_m1':
              className = 'ol-scale-oecd-top-line'
              break            
            case 'oecd_m1':
              className = 'ol-scale-oecd-top-line'
              break
            case 'oecd_m4':
            case 'oecd_m3':
              className = 'ol-scale-oecd-line'
              break
            case 'oecd_m2': 
            case 'oecd_m21':
            case 'oecd_m22':
              className = 'ol-scale-oecd-small-line'
              break
          }

          let control = new ScaleLine({
            units: 'metric',
            bar: false,
            steps: 1,
            text: false,
            minWidth: 45,
            className: className,
            //target: document.getElementById('mappaMini' + this.id)
          });
          return control;
        },

        initMap() {
          let self = this
          console.log(this.map)
          if (!this.map) {
            console.log('>>>>>INIT MAP<<<<');
            let params = this.$route.params 
            let map_code = 'ckue39x386geb17mpekklxc7a'

/*              this.BordersLayer = new VectorImageLayer({
              name: "countries",
              imageRatio: 2,
              source: this.$store.getters.countries_polygon
              })    */
           
            if (params.tl === 'EFUA' || params.tl === 'CY' || params.tl === 'FUA' ) {
               map_code = 'ckue39x386geb17mpekklxc7a'
            }

            if (params.tu !== 'x') {
              // city name (no border)
              map_code = 'ckue3fbzc1uji18ohxi2qlvov'
            }
            this.OsmLayer = new TileLayer({
              name: "map",
              source: new XYZ({
                url: 'https://api.mapbox.com/styles/v1/glauco70/' + map_code + '/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZ2xhdWNvNzAiLCJhIjoiY2tkaGVnYTBzMTB5MjJ0b2JhNXdjNGlubCJ9.IxZcymhH8V37P83VttrVxA',
                crossOrigin: "Anonymous",
              })
            })

            
            this.polygon_layer = this.main_layer
            let ls = this.getLayerSource(this.projection)

            let view
            if (this.projection){
              let prj = ''
              if (this.projection === 'ESRI:102009') {
                prj = this.$store.getters.NorthAmericaProjection
              }
              else if (this.projection === 'EPSG:3035') {
                prj = this.$store.getters.EuropeProjection
              }
              
              view = new View({
                center: [0, 0],
                zoom: 0,
                projection: prj
              })              
            }
            else {
              view = new View({
                center: [0, 0],
                zoom: 0
              })
            }
            console.log(ls)
            if (ls) {
                // this.polygon_layer = ls
                // let source = this.getLayerSource()
                // console.log(source)
                let style = new Style({
                    fill: new Fill({
                    // color: 'rgba(255, 255, 255, 0.8)'
                    color: 'rgba(12, 30, 210, 0.3)'
                    }),
                    stroke: new Stroke({
                      color: '#319FD3',
                    width: 1,
                    })
                })

                this.polygon_layer = new VectorImageLayer({
                    imageRatio: 2,
                    source: ls,
                    name: "polygon",
                    style: function() {
                        return style
                    }
                })
            }

            let layers = []
            layers = [this.polygon_layer, this.OsmLayer]
            console.log(layers)
            //layers = [this.polygon_layer, this.OsmLayer, this.BordersLayer]

            var interactions = ''
            if (params.tu !== 'x') {
              interactions = new defaults({
                doubleClickZoom: false,
                dragAndDrop: false,
                dragPan: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
              })
            }

            this.map = new Map({
              layers: layers,
              overlays: [this.overlayPopup],
              interactions: interactions,
              /*
              layers: [
                new TileLayer({
                  source: new OSM(),
                }),this.polygon_layer ],
              */
              target: 'mappaMini' + this.id,
              view: view,
            })

            this.map.addControl(this.scaleControl());
            this.addTextToOECDMaps()

            this.map.on('click', (args) => {

              let atts = null
              this.map.forEachFeatureAtPixel(args.pixel, (feature) => {
                if (!atts) {
                  atts = feature.getProperties()
                  // console.log(atts)
                }
              })
              // this.map.forEachFeatureAtPixel(args.pixel, (feature) => {
                  // var atts = feature.getProperties()
                  // console.log(atts)
                  let params = this.$route.params 
                  let tl = params.tl
                  let tu = params.tu
                  let atts_code = atts.CODE
                  console.log(atts)
                  if (tl === 'FUA' && tu !== 'x') {
                    atts_code = atts.fuacode
                    atts_code = atts_code.substring(0,atts_code.length -1)
                    }
                  if (tl === 'EFUA' && tu !== 'x') {
                    atts_code = String(atts.eFUA_ID)
                    }  
                  if (tl === 'CY' && tu !== 'x') {
                    atts_code = String(atts.eFUA_ID)
                    }  
                  if (atts_code !== undefined) {
                    if (!atts.noclick) {
                      this.$root.$emit('change_tu', atts_code) 
                    }
                  }
              // })

            })
            this.map.on('pointermove', (args) => {
              let f = 0
              let atts = null
              this.map.forEachFeatureAtPixel(args.pixel, (feature) => {
                if (!atts) {
                  atts = feature.getProperties()
                }
              })
              // this.map.forEachFeatureAtPixel(args.pixel, (feature) => {
              // let atts = feature.getProperties()
              // console.log(atts)
              if (atts !== null){
              let ds = this.$store.getters.ds
              
              if (ds) {
                let params = this.$route.params 
                let tl = params.tl
                let tu = params.tu
                let atts_code = atts.CODE
                let atts_name = atts.NAME

                if (tl === 'FUA' && tu !== 'x') {
                  atts_code = atts.fuacode
                  atts_name = atts.fuaname_en
                }
                if (tl === 'EFUA' && tu !== 'x') {
                  atts_code = atts.eFUA_ID
                  atts_name = atts.eFUA_name
                }                    
                if (tl === 'CY' && tu !== 'x') {
                  atts_code = atts.eFUA_ID
                  atts_name = atts.eFUA_name
                }                    
              
                if (atts_code !== undefined) {
                  f++
                  let coordinate = args.coordinate
                  let year = this.$store.getters.year.toString()
                  // console.log(year)
                  let numberFormatted = ''
                  let value = null
                  if (ds.Data) {
                    if (tl === 'FUA') {
                      console.log(atts_code)
                      console.log(year)
                      value = ds.Data({METRO_ID: atts_code, TIME_PERIOD: year}).value
                    } else {
                      value = ds.Data({REG_ID: atts_code, TIME: year}).value
                    }
                  } 
                  else {
                    if (tl === 'CY'  || tl === 'EFUA' || tl === 'TL2' || tl === 'TL3'|| tl === 'FUA') {
                      value = ds.dataset[year][atts_code]
                    }
                  }
                  /*
                  if (value) {
                    numberFormatted = formatNumber(value)
                  }
                  */
                  numberFormatted = formatNumber(value)

                  try {
                    //if (atts.CODE != self.prevCode) {
                      // self.content.innerHTML = '<b>' +  atts_name + '</b>: ' + numberFormatted + ' (' + year + ')'
                      if (numberFormatted !== undefined) {
                        self.content.innerHTML = '<b>' +  atts_name + '</b>: ' + numberFormatted
                      } else {
                        self.content.innerHTML = '<b>' +  atts_name + '</b>'
                      }
                      self.prevCode = atts_code
                    // }
                  } catch (error) {
                    console.log(error)
                  }
                  self.overlayPopup.setPosition(coordinate)                    
                }
              }
              // })
              if (f === 0) {
                self.overlayPopup.setPosition(undefined)
              }
              }
            })

            this.map.on('moveend', this.onMoveEnd)
          }
          try {
            let layers = this.map.getLayers() 
            let self = this

            layers.forEach(function(el) {
              if (el.get('name') === 'map') {
                el.setZIndex(-10)            
              }
              //if (el.get('name') === 'countries') {
                //el.setZIndex(10)            
              //}          
              if (el.get('name') === 'polygon') {
                el.setSource(self.getLayerSource(self.projection))
                el.setZIndex(100)
              }          
              })

          } catch (error) {
            console.log(error)
          }

          this.$root.$once('zoom_in', () => {
            this.zoomIn()
          })
          this.$root.$once('zoom_out', () => {
            this.zoomOut()
          })
          this.$root.$once('map_2_pdf', () => {
            this.exportMap('PDF')
          })
          this.$root.$once('map_2_jpg', () => {
            this.exportMap('JPG')
          })
          this.$root.$once('remove_legend_from_map', () => {
            this.removeLegendFromMap()
          })

        },
        _removeLegendFromMap() {
           if (this.map !== undefined) {
            this.map.removeControl(this.controlLegend)
            }
        },
        removeLegendFromMap() {
          //console.log('>>>>remove_legend_from_map')
          this._removeLegendFromMap()
          this.$root.$once('remove_legend_from_map', () => {
            this.removeLegendFromMap()
          })                        
        },
        
        addLegendToMap() {
            this._removeLegendFromMap()
            var innerHTML = ''
            var legendC = this.$store.getters.legendColors
            var legendT = this.$store.getters.legendThresholds

            //innerHTML = innerHTML + "<img src=\"../assets/img/oecd-logo.png\"></img>"
            innerHTML = innerHTML + "<div class=\"opensansbold size11 text-left mb-2\">" + this.$store.getters.indicatorTitle + "</div>"
            innerHTML = innerHTML + "<div class=\"opensansregular size9 text-left text-lowercase mb-2\"> ("+ this.$store.getters.indicatorUnit + ") </div>"

            var index = 0
            legendC.forEach(element => {
              if (index < 5) {
                innerHTML = innerHTML + "<div style=\"background:" + element.toString() +";\" class=\"color_indicator\"></div>"
                if (index < 4) {
                  innerHTML = innerHTML  + "<div class=\"legend_descriptor opensanslight size8\">" +  formatNumber(legendT[index]) + " - " + formatNumber(legendT[index+1]) + "</div></div><br/>"
                }
              }
              if (index == 4) {
                innerHTML = innerHTML  + "<div class=\"legend_descriptor opensanslight size8\">" + "> " +  formatNumber(legendT[index]) + "</div>"
              }

              index = index +1            
            }); 

            var element = document.createElement('div');
            element.className = 'ol-control-panel ol-unselectable ol-control';
            element.innerHTML= innerHTML
            this.controlLegend = new Control({
                element: element
            });
            this.map.addControl(this.controlLegend)
        },

        addTextToOECDMaps() {
          var text = ''

          switch (this.id) {
            case 'oecd_m12':
              text = 'Chile'
              break
            case 'oecd_m13':
              text = 'Hawaiian Islands (US)'
              break
            case 'oecd_m14':
              text = 'Alaska (US)'
              break
            case 'oecd_m15':
              text = 'Costa Rica'
              break
            case 'oecd_m16':
              text = 'Colombia'
              break
            case 'oecd_m21':
              text = 'Canarian Islands (ES)'
              break
            case 'oecd_m22':
              text = 'Israel'
              break                            
          }
          if (text !== '') {
            var innerHTML = ''
            innerHTML = innerHTML + "<div>" + text + "</div>"

            var element = document.createElement('div');
            element.className = "OpenSansLight size7 text-right mr-2 mt-2"
            element.innerHTML= innerHTML
            let textOECD = new Control({
                element: element
            });
            this.map.addControl(textOECD)
          }
        },

      onMoveEnd(evt) {
        let map = evt.map;
        let extent = map.getView().calculateExtent(map.getSize())
        let bottomLeft = toLonLat(getBottomLeft(extent))
        let topRight = toLonLat(getTopRight(extent))
        this.$store.commit("setMoveMap", {map: this.id, coord: [topRight, bottomLeft]})
      },
      getLayerSource(projection) {
        if (projection == 'ESRI:102009') {
          return this.$store.getters.current_polygonsNorthAmerica
        }
        else if (projection == 'EPSG:3035') {
          return this.$store.getters.current_polygonsEurope
        }
        else {
          return this.$store.getters.current_polygons
        }
      },
      changeLayers() {
        console.log('*** changeLayers ***')
        let layers = this.map.getLayers() 
        let self = this
        let params = this.$route.params
        layers.forEach(function(el) {

          if (el.get('name') === 'map') {
            if (self.changeTL === true) {
              self.changeTL = false
              let map_code = 'ckue39x386geb17mpekklxc7a'
            
              if (params.tl === 'EFUA' || params.tl === 'FUA' || params.tl === 'CY' ) {
                  // borders
                  map_code = 'ckue39x386geb17mpekklxc7a'
              }
              if (params.tu !== 'x') {
                // city name (no border)
                map_code = 'ckue3fbzc1uji18ohxi2qlvov'
              }
              let source = new XYZ({
                url: 'https://api.mapbox.com/styles/v1/glauco70/' + map_code + '/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZ2xhdWNvNzAiLCJhIjoiY2tkaGVnYTBzMTB5MjJ0b2JhNXdjNGlubCJ9.IxZcymhH8V37P83VttrVxA',
                crossOrigin: "Anonymous"
              })
              el.setSource(undefined)
              el.setSource(source)
            }
            el.setZIndex(-10)            
          }
                 
          if (el.get('name') === 'polygon') {
            el.setSource(null)
            el.setSource(self.getLayerSource(self.projection))
            el.setZIndex(100)
          }          
          })
                },
      onResize: function() {
        this.zoomToExtent()
      },

      centerMap() {
        console.log('>>>>>>>>>> centerMap');
        let tl = this.$store.getters.TL
        let code = null
        if (tl === "FUA") {
          code = this.$store.getters.getFUAByCode(this.$store.getters.TU)
        }
        else if (tl === "EFUA") {
          code = this.$store.getters.getEFUAByCode(this.$store.getters.TU)
        }        
        else if (tl === "CY") {
          code = this.$store.getters.getCYByCode(this.$store.getters.TU)
        }
        console.log(code)
        if (code) {
          this.map.setView(new View({
              center: proj.fromLonLat([parseFloat(code.lon), parseFloat(code.lat)]),
              zoom: 8
          }))
        }
      },

      zoomToExtent() {
        console.log(this.$route.query.m)
        console.log(this.id)
        if (this.$route.query.m) {
          if (this.$route.query.m === this.id) {
            // It's rect for map
            console.log(this.$route.query.rect)
            let arr = this.$route.query.rect.split(',')
            let top = [parseFloat(arr[0]), parseFloat(arr[1])]
            let bottom = [parseFloat(arr[2]), parseFloat(arr[3])]
            const start = proj.fromLonLat(top)
            const end = proj.fromLonLat(bottom)
            let geometry = new Polygon([[start, end]]) 
            this.map.getView().fit(geometry, this.map.getSize())
            return
          }
        }

        let params = this.$route.params 
        let tl = params.tl
        let tu = params.tu

        console.log(tl)
        console.log(tu)

        if (tu !== 'x') {
          if (tl === 'EFUA???') {
            this.centerMap()
          }
          else {
            let tu_obj = null
            if (tl === 'TL2') {
              // tu_obj = this.$store.getters.objTL2.filter(v => v.code.includes(tu))
              // tu_obj = this.$store.getters.objTL3.filter(v => v.code.includes(tu))
              tu_obj = this.$store.getters.objTL2.features.filter(v => v.properties.CODE.includes(tu))
            }
            if (tl === 'TL3') {
              // tu_obj = this.$store.getters.objTL3.filter(v => v.code.includes(tu))
              tu_obj = this.$store.getters.objTL3.features.filter(v => v.properties.CODE.includes(tu))
            }
            if (tl === 'FUA') {
              // tu_obj = this.$store.getters.objTL3.filter(v => v.code.includes(tu))
              // tu_obj = this.$store.getters.objFUA.features.filter(v => v.properties.fuacode.includes(tu))
              tu_obj = [this.$store.getters.objFUA.features[0]]
              /*
              let tableFUACities = this.$store.getters.TableFUACities
              tableFUACities = tableFUACities[tu+'F']
              let cities = this.$store.getters.CY
              for (let f of tableFUACities) {
                let id = f.substring(0,f.length -1)
                for (let c of cities) {
                  if (c.id === id) {
                    console.log(c.lat)
                    console.log(c.lon)
                    console.log(c.name)
                  }
                }
              } 
              */
            }
            if (tl === 'EFUA') {
              // tu_obj = this.$store.getters.objTL3.filter(v => v.code.includes(tu))
              console.log(this.$store.getters.objEFUA)
              tu_obj = [this.$store.getters.objEFUA.features[0]]
            }
            if (tl === 'CY') {
              tu_obj = [this.$store.getters.objCY.features[0]]
            }

            console.log(tu_obj)

            if (tu_obj) {
              // let tu_obj = this.$store.getters.objTL2.filter(v => v.code.includes(tu))
              // console.log(tu_obj)
              // let coordinates = tu_obj[0]['coordinates'][0]
              let coordinates 
              let feature = null
              if (tl === 'TL3' || tl === 'TL2' || tl === 'EFUA' || tl === 'CY' ||  tl === 'FUA') {
                console.log(tl)
                coordinates = tu_obj[0]['geometry']['coordinates']
                let type = tu_obj[0]['geometry']['type']
                console.log(type)
                if (type === 'Polygon') {
                  feature = new Feature({
                    geometry: new Polygon(coordinates),
                    name: 'My Polygon'
                  })
                } else if (type === 'MultiPolygon') {
                  feature = new Feature({
                    geometry: new MultiPolygon(coordinates),
                    name: 'My Polygon'
                  })
                } else {
                  console.log('type unknown')
                  console.log(type)
                }
              } else {
                coordinates = tu_obj[0]['coordinates']
                //console.log(coordinates)
                if (tu_obj[0].type === 'Polygon') {
                  feature = new Feature({
                    geometry: new Polygon(coordinates),
                    name: 'My Polygon'
                  })
                } else if (tu_obj[0].type === 'MultiPolygon') {
                  feature = new Feature({
                    geometry: new MultiPolygon(coordinates),
                    name: 'My Polygon'
                  })
                } else {
                  console.log('type unknown')
                  console.log(tu_obj[0].type)
                }
              }
              if (feature) {
                let dest = 'EPSG:3857'
                let src = 'EPSG:4326'
                
                if (tl === 'EFUA' || tl === 'CY' || tl === 'FUA') {
                    src = 'EPSG:3857'
                }

                console.log(tl)
                console.log(src)
                console.log(dest)

                let feat2 = feature.getGeometry().transform(src, dest)
                // feat2 = feature.getGeometry()
                //console.log(feat2)                
                this.map.getView().fit(feat2, {padding: [100, 30, 30, 100], minResolution: 800}) 
                // this.map.getView().fit(feat2, this.map.getSize()) 
                // this.$root.$emit('component_refresh')
              }
            }
          }
        } else {
          console.log('Center map all')
          let geometry = null
          let start = ''
          let end = ''
          //const toNumbers = arr => arr.map(Number)
          if (typeof this.start == 'string') {
            start = this.start.split(" ")
            end = this.end.split(" ")
          }
          else {
            start = proj.fromLonLat(this.start)
            end = proj.fromLonLat(this.end)
          }

          //if (this.projection){
          //  start = proj4('EPSG:3857', this.projection, toNumbers(start));
          //  end = proj4('EPSG:3857', this.projection, toNumbers(end));
          //}
          geometry = new Polygon([[start, end]]) 

          if (this.map){
            this.map.getView().fit(geometry, this.map.getSize())
          }
        }
      },
      zoomIn: function() {
        if (this.map) {
          var view = this.map.getView()
          var zoom = view.getZoom()
          view.setZoom(zoom + .4)
          this.$root.$once('zoom_in', () => {
            this.zoomIn()
          })
          }
      },      
      zoomOut: function() {
        if (this.map) {
          var view = this.map.getView()
          var zoom = view.getZoom()
          view.setZoom(zoom - .4)
          this.$root.$once('zoom_out', () => {
            this.zoomOut()
          })
          }
      },
    },
    data () {
      let map = null
      let overlay = false
      let polygon_layer = null
      let OsmLayer = null
      //let BordersLayer = null
      let overlayPopup = null
      let content = null
      let controlLegend = null
      let prevCode = ''
      let changeTL = false
      let northAmerica = ''
      let europe = ''
      return {
        map, 
        overlay, 
        polygon_layer,
        OsmLayer,
        //BordersLayer,
        overlayPopup,
        content,
        controlLegend,
        prevCode,
        changeTL,
        northAmerica,
        europe
      }
    }, 
  computed: {

  },     
  beforeDestroy() {
    //console.log("*** MAP2 DESTROYED  ****" + this.id)
    delete this.map
    delete this.overlay
    delete this.overlayPopup
    delete this.polygon_layer
    delete this.OsmLayer
    //delete this.BordersLayer
    delete this.controlLegend
    delete this.content
  },
  mounted () {
    console.log("*** MAP2 MOUNTED **** " + this.id)
    this.setOverlayPopup()
    this.initMap()
    this.zoomToExtent()
  }   
}
</script>
<style>
   .ol-scale-line {
  }
  .ol-scale-oecd-line
  {
  }
  .ol-scale-oecd-top-line
  {
  }
  .ol-scale-oecd-small-line
  {    
  }
  .ol-scale-line-inner {
    font-size: 8px;
    color: #703841ff;
    border: 1px solid #703841ff;
    border-top: none;
    background: rgba(224, 224, 224, 0.5);
  }

  .ol-scale-oecd-line-inner {
    font-size: 8px;
    position: absolute;
    width: 10px;
    bottom: 1em;
    right: 1px;
    color: #703841ff;
    border: 1px solid #703841ff;
    border-top: none;
    background: rgba(224, 224, 224, 0.5);
  }

  .ol-scale-oecd-top-line-inner {
    font-size: 8px;
    position: absolute;
    width: 10px;
    top: 1em;
    right: 1px;
    color: #703841ff;
    border: 1px solid #703841ff;
    border-top: none;
    background: rgba(224, 224, 224, 0.5);
  }

  .ol-scale-oecd-small-line-inner {
    font-size: 6px;
    position: absolute;
    width: 10px;
    bottom: 1em;
    right: 1px;
    color: #703841ff;
    border: 1px solid #703841ff;
    border-top: none;
    background: rgba(224, 224, 224, 0.5);
  }

  .ol-zoom {
    display: none;
  }
  .map {
    height: 38vh;
    width: 100%;
    border: 0px solid gray;
  }
  .mapbig {
    height: 80vh;
    width: 100%;
    border: 0px solid gray;
  }
  .maplarge {
    height: 65vh;
    width: 98%;
    border: 1px solid gray;
  }  
  .mapmedium {
    height: 49vh;
    width: 100%;
    border: 1px solid gray;
  }
  .maplittle {
    height: 27vh;
    width: 100%;
    border: 1px solid gray;
  }
  .mapover1 {
    height: 64vh;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: 0px;
    left: 0px;
    border: 1px solid gray;
  }      
  .mapover12 {
    height: 50vh;
    width: 10vh;
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 0px;
    border: 1px solid gray;
  }
  .mapover13 {
    height: 14vh;
    width: 12vh;
    position: absolute;
    z-index: 3;
    top: 50vh;
    left: 0px;
    border: 1px solid gray;
  }
  .mapover14 {
    height: 14vh;
    width: 14vh;
    position: absolute;
    z-index: 4;
    top: 0px;
    left: 0px;
    border: 1px solid gray;
  }
  .mapover15 {
    height: 12vh;
    width: 12vh;
    position: absolute;
    z-index: 3;
    top: 52vh;
    left: 22vh;
    border: 1px solid gray;
  }
  .mapover16 {
    height: 14vh;
    width: 14vh;
    position: absolute;
    right: 1px;
    z-index: 3;
    top: 50vh;
    left: 12vh;
    border: 1px solid gray;
  }

  .mapover2 {
    height: 46vh;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: 0px;
    left: 0px;
    border: 1px solid gray;
  }                 
  .mapover21 {
    height: 14vh;
    width: 14vh;
    position: absolute;
    z-index: 2;
    top: 18vh;
    left: 0px;
    border: 1px solid gray;
  }      
  .mapover22 {
    height: 14vh;
    width: 14vh;
    position: absolute;
    z-index: 3;
    top: 32vh;
    left: 0px;
    border: 1px solid gray;
  }            

  .mapover4 {
    height: 18vh;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: 46vh;
    left: 0px;        
    border: 1px solid gray;
  } 

.ol-attribution {
  display: none;
}

.mapcontainer {
  position: relative;
}

.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 50px;
  width:100px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}
</style>
